export const customPageStatusEnum = {
    0: 'unpublished',
    1: 'published',
};

export const customPageFeaturedEnum = {
    0: 'notFeatured',
    1: 'featured'
};